import { Delta } from "quill";
import { create } from "zustand";

const useClient = create<{
  notesOpen: boolean;
  setNotesOpen: (open: boolean) => void;
  notes: Delta;
  setNotes: (notes: Delta) => void;
}>((set) => ({
  notesOpen: false,
  notes: new Delta(),
  setNotesOpen: (x: boolean) => set(() => ({ notesOpen: x })),
  setNotes: (notes: Delta) => set(() => ({ notes })),
}));

export default useClient;
